// CMS utils
export function getClientCloudinaryMedia(fileType, keyword, antiKeyword) {
  var cldImages = require("../_cloudinary/cloudinary.json")
  let cldImagesFinal = []

  if (fileType) {
    for (let i = 0; i < cldImages.length; i++) {
      if (cldImages[i].format === fileType) {
        cldImagesFinal.push(cldImages[i].public_id)
      }
    }
  } else if (keyword) {
    for (let i = 0; i < cldImages.length; i++) {
      if (cldImages[i].public_id.includes(keyword)) {
        if (antiKeyword && !cldImages[i].public_id.includes(antiKeyword)) {
          cldImagesFinal.push(cldImages[i].public_id)
        } else if (!antiKeyword) {
          cldImagesFinal.push(cldImages[i].public_id)
        }
      }
    }
  } else {
    for (let i = 0; i < cldImages.length; i++) {
      cldImagesFinal.push(cldImages[i].public_id)
    }
  }
  return cldImagesFinal
}

export function getPostObj(
  pageContext,
  englishNodes,
  spanishNodes,
  russianNodes
) {
  let post
  let language

  try {
    post = setEnglishOrSpanishPost(
      pageContext.language,
      englishNodes,
      spanishNodes,
      russianNodes
    )
    language = pageContext.language
  } catch (err) {
    console.warn(err)
    post = englishNodes
    language = "en"
  }

  return { post: post, language: language }
}

function setEnglishOrSpanishPost(
  language,
  englishNodes,
  spanishNodes,
  russianNodes
) {
  let post

  switch (language) {
    case "en":
      post = englishNodes
      break
    case "es":
      post = spanishNodes
      break
    case "ru":
      post = russianNodes
      break
    default:
      post = englishNodes
  }

  return post
}

// General Utils
export function sortArchive(archiveArray) {
  archiveArray.sort((a, b) => (a.order > b.order ? 1 : -1))
}

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
}

export function getMonthYearFromStrings(year, month, language) {
  var localeLanguage
  if (language === "es") {
    localeLanguage = "es-ES"
  }
  const yearInt = parseInt(year)
  const monthInt = parseInt(month) - 1
  const date = new Date(yearInt, monthInt) // 2009-11-10
  const monthStr = date.toLocaleString(localeLanguage, { month: "long" })
  return capitalizeFirstLetter(monthStr) + " " + yearInt
}

export function capitalizeFirstLetter(s) {
  if (typeof s !== "string") return ""
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function getUnique(startingArray, targetProperty, valueToCompare) {
  let properties = []
  for (let i = 0; i < startingArray.length; i++) {
    properties.push(startingArray[i][targetProperty])
  }
  if (properties.includes(valueToCompare)) {
    return false
  }
  return true
}

export function getUnrelatedReviews(targetArray, allElements, targetProperty) {
  var elementsWithTargetProperty = []
  var nonMatching = []

  elementsWithTargetProperty = getOnlyElementsWithTargetProperty(
    targetArray,
    targetProperty
  )
  nonMatching = getNonMatchingObjectsFromAllElements(
    elementsWithTargetProperty,
    allElements,
    targetProperty
  )
  return nonMatching
}

function getOnlyElementsWithTargetProperty(array, targetProperty) {
  var elementsWithTargetProperty = []
  for (let i = 0; i < array.length; i++) {
    if (array[i] && array[i].title) {
      elementsWithTargetProperty.push(array[i][targetProperty])
    }
  }
  return elementsWithTargetProperty
}
function getNonMatchingObjectsFromAllElements(
  elementsWithTargetProperty,
  allElements,
  targetProperty
) {
  var nonMatching = []
  for (let i = 0; i < allElements.length; i++) {
    if (
      elementsWithTargetProperty.includes(allElements[i][targetProperty]) ===
      false
    ) {
      nonMatching.push(allElements[i])
    }
  }
  return nonMatching
}

export function sortReviewsByDate(reviews) {
  reviews.sort(function (a, b) {
    var aYear = a.monthYear.year
    var bYear = b.monthYear.year
    var aMonth = a.monthYear.month
    var bMonth = b.monthYear.month

    return bYear - aYear || bMonth - aMonth
  })
  return reviews
}

// Procedures functions
export function getFeaturedProceduresAndOtherProceduresObject(procedures) {
  var featuredProcedures = []
  var otherProcedures = []
  for (let i = 0; i < procedures.length; i++) {
    if (procedures[i].procedureLevel === "featured") {
      featuredProcedures.push(procedures[i])
    } else {
      otherProcedures.push(procedures[i])
    }
  }
  return { featuredProcedures, otherProcedures }
}

export function getHearFromHeadingAndBlurbObject(
  procedure,
  originalReviewCount
) {
  var heading
  var blurb

  if (isFacewallTextGeneric(procedure, originalReviewCount)) {
    heading = "Hear From Our Patients"
    blurb = ""
  } else {
    heading = "Hear From ".concat(
      removeRball(procedure.nameSingular),
      " Patients"
    )
    if (
      procedure.nameSingular.toLowerCase() === "wisdom tooth removal" ||
      procedure.nameSingular.toLowerCase() === "cost of wisdom teeth removal"
    ) {
      heading = "Hear From Wisdom Teeth Removal Patients"
    }
    blurb =
      "These patients can tell you about their firsthand experience undergoing ".concat(
        removeRball(procedure.nameSingular).toLowerCase(),
        " at our office."
      )
    if (procedure.nameSingular.toLowerCase() === "dental implant") {
      blurb =
        "These patients can tell you about their firsthand experience undergoing dental implant treatment at our office."
    }
    if (procedure.nameSingular.toLowerCase() === "impacted canine") {
      blurb =
        "These patients can tell you about their firsthand experience undergoing impacted canine treatment at our office."
    }
    if (procedure.nameSingular.toLowerCase() === "oral pathology") {
      blurb =
        "These patients can tell you about their firsthand experience undergoing oral pathology treatment at our office."
    }
    if (procedure.nameSingular.toLowerCase() === "facial trauma") {
      blurb =
        "These patients can tell you about their firsthand experience undergoing facial trauma treatment at our office."
    }
    if (procedure.nameSingular.toLowerCase() === "tmj disorder") {
      blurb =
        "These patients can tell you about their firsthand experience undergoing TMJ disorder treatment at our office."
    }
    if (procedure.nameSingular.toLowerCase() === "sleep apnea") {
      blurb =
        "These patients can tell you about their firsthand experience undergoing sleep apnea treatment at our office."
    }
    if (procedure.nameSingular.toLowerCase() === "tooth replacement option") {
      blurb =
        "These patients can tell you about their firsthand experience undergoing tooth replacement at our office."
    }
    if (
      procedure.nameSingular.toLowerCase() === "cost of wisdom teeth removal"
    ) {
      blurb =
        "These patients can tell you about their firsthand experience undergoing wisdom teeth removal at our office."
    }
    if (procedure.nameSingular.toLowerCase() === "dental implant financing") {
      heading = "Hear From Dental Implant Patients"
      blurb =
        "These patients can tell you about their firsthand experience undergoing dental implant treatment at our office."
    }
    if (procedure.nameSingular.toLowerCase().includes("all-on-4")) {
      let nameSingular = removeRball(procedure.nameSingular).toLowerCase()
      nameSingular = capitalizeFirstLetter(nameSingular)

      blurb =
        "These patients can tell you about their firsthand experience undergoing " +
        nameSingular +
        " at our office."
    }
  }

  return { heading, blurb }
}
export function isFacewallTextGeneric(procedure, originalReviewCount) {
  // 4 because that is the number of reviews possible in the current FixedFacewall
  if (procedure.nameSingular === null || originalReviewCount < 4) {
    return true
  }
  return false
}

export function createHtml(html) {
  return { __html: html }
}

export function toCamelCase(string) {
  string = string.trim()
  try {
    let out = ""
    string.split(" ").forEach((el, idx) => {
      let add = el.toLowerCase()
      out += idx === 0 ? add : add[0].toUpperCase() + add.slice(1)
    })
    return out
  } catch (err) {}
}

export function splitCamelCaseToString(string) {
  return string.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
    return str.toUpperCase()
  })
}

//Turns query string like hello=1&another=2 into object {hello: 1, another: 2}
export function parseSearchQuery(queryString) {
  var query = {}
  var pairs = (
    queryString[0] === "?" ? queryString.substr(1) : queryString
  ).split("&")
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=")
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "")
  }
  return query
}

export function pluralizeName(name) {
  const lastLetter = name.charAt(name.length - 1)
  if (lastLetter.toLowerCase() === "s") {
    return `${name}'`
  } else {
    return `${name}'s`
  }
}

export function telephoneStrip(phone) {
  return phone.replace(/[^\d]/g, "")
}

export function wrapSup(string) {
  return string.replace(/((?!<sup>\s*))®((?!\s*<\/sup>))/gi, "<sup>®</sup>")
}

export function removeRball(string) {
  return string.replace(/((?!<sup>\s*))®((?!\s*<\/sup>))/gi, "")
}

// Find variables in strings and replace them
// Variables must be wrapped in curly brackets. ex. {MY_VARIABLE}
// string = string
// obj = object of matching variables
//        {
//          MY_VARIABLE: "replaces variable with this text"
//        }
export function replaceStringVars(string, obj) {
  let s = string
  for (var prop in obj) {
    s = s.replace(new RegExp("{" + prop + "}", "g"), obj[prop])
  }
  return s
}

// Removes https, slashes, www from URLs
export function cleanURL(url) {
  return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split("/")[0]
}

export function convertTime12to24(time12h) {
  const [time, modifier] = time12h.split(" ")

  let [hours, minutes] = time.split(":")

  if (hours === "12") {
    hours = "00"
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12
  }

  return `${hours}:${minutes}`
}

export const toTitleCase = str => {
  return str.replace(/(^|\s)\S/g, function (t) {
    return t.toUpperCase()
  })
}

export const toSentenceCase = str => {
  return str.replace(/\.\s+([a-z])[^\.]|^(\s*[a-z])[^\.]/g, s =>
    s.replace(/([a-z])/, s => s.toUpperCase())
  )
}
